export const RETAILER_ONBOARDING = {
    ROOT: "retailer-onaboarding-page",
    STEPS: {
        SPLASH: "SPLASH",
        RETAILER_ONRBOARDING_SETUP_STEP: "retailer-onboarding-setup-step",
        RETAILER_ONRBOARDING_CREATE_PROFILE_STEP: "retailer-onboarding-create-profile-step",
        RETAILER_ONRBOARDING_CREATE_PROFILE_STEP_FORM: "retailer-onboarding-create-profile-step-form",
    },
    STEPPER: "retailer-onboarding-stepper",
};
